import React, { Component } from 'react'

import Grid from '@material-ui/core/Grid'
import GridContainer from './GridContainer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'

import iddLogo from './../../assets/images/italia-destinazione-digitale-logo.png'
import './NavBar.css'

class NavBar extends Component {

  constructor(props) {
      super(props)
  }  
    
  render() {

    return (
        <AppBar className="shared-nav-bar" position="static" color="default">
            <Toolbar disableGutters={true}>

                <GridContainer>
                    <Grid item xs={12}>
                        <a href="https://www.destinazionedigitale.it/" target="_blank">
                            <img src={iddLogo} className="shared-nav-bar__logo"/>
                        </a>
                    </Grid>
                </GridContainer>
                
            </Toolbar>
        </AppBar>
    )
  }
}

export default NavBar


// WEBPACK FOOTER //
// ./src/components/shared/NavBar.js